import { render, staticRenderFns } from "./CardGame.vue?vue&type=template&id=0ff69f16&"
import script from "./CardGame.vue?vue&type=script&lang=js&"
export * from "./CardGame.vue?vue&type=script&lang=js&"
import style0 from "./CardGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports